<template>
  <div>
    <div class="top">
      <div class="header">
        <!--        <img alt="logo" class="logo" src="@/assets/img/logo.png"/>-->
        <span class="title">{{ systemName }}</span>
      </div>
<!--      <div class="boxes" style="width: 100%;margin-top:200px">-->
<!--        <a href="https://work.weixin.qq.com/wework_admin/commdownload?platform=win&from=baidu">-->
<!--          <div class="first">-->
<!--            <span>Windows桌面端</span>-->
<!--            <p class="p1">点击直接下载</p>-->

<!--          </div>-->
<!--        </a>-->
<!--        <a href="https://work.weixin.qq.com/wework_admin/commdownload?platform=mac&from=baidu">-->
<!--          <div class="second">-->
<!--            <span>Mac桌面端</span>-->
<!--            <p class="p2">点击直接下载</p>-->

<!--          </div>-->
<!--        </a>-->
<!--        <a href="https://work.weixin.qq.com/wework_admin/commdownload?platform=ios&from=baidu">-->
<!--          <div class="third">-->
<!--            <span>IOS版</span>-->
<!--            <p class="p3">扫描二维码下载</p>-->
<!--          </div>-->
<!--        </a>-->
<!--        <a href="https://work.weixin.qq.com/wework_admin/commdownload?platform=android&from=baidu">-->
<!--          <div class="forth">-->
<!--            <span>Android版</span>-->
<!--            <p class="p4">扫描二维码下载</p>-->
<!--          </div>-->
<!--        </a>-->
<!--      </div>-->
<!--      <span style="margin-top: 100px;height: 20px;display: block">请使用企业微信内个人中心登录</span>-->
    </div>

        <div class="login">
          <a-form @submit="onSubmit" :form="form">
            <a-tabs size="large" :tabBarStyle="{textAlign: 'center'}" style="padding: 0 2px;">
              <a-tab-pane tab="账户密码登录" key="1">
                <a-alert type="error" :closable="true" v-show="error" :message="error" showIcon
                         style="margin-bottom: 24px;"/>
                <a-form-item>
                  <a-input
                      autocomplete="autocomplete"
                      size="large"
                      placeholder="请输入账户名"
                      v-decorator="['username', {rules: [{ required: true, message: '请输入账户名', whitespace: true}]}]"
                  >
                    <a-icon slot="prefix" type="user"/>
                  </a-input>
                </a-form-item>
                <a-form-item>
                  <a-input
                      size="large"
                      placeholder="请输入密码"
                      autocomplete="autocomplete"
                      type="password"
                      v-decorator="['password', {rules: [{ required: true, message: '请输入密码', whitespace: true}]}]"
                  >
                    <a-icon slot="prefix" type="lock"/>
                  </a-input>
                </a-form-item>
              </a-tab-pane>
            </a-tabs>
            <a-form-item>
              <a-button :loading="logging" style="width: 100%;margin-top: 24px" size="large" htmlType="submit"
                        type="primary">登录
              </a-button>
            </a-form-item>
          </a-form>
        </div>
  </div>
</template>

<script>
import {login, getRoutesConfig, getUserInfo, getPermissions} from '@/services/user'
import {setAuthorization} from '@/utils/request'
import {loadRoutes} from '@/utils/routerUtil'
import {mapMutations} from 'vuex'
import {convertMenuConfigToRouteConfig} from '@/utils/ebase-menu'
import api from '@/services/api'
import Cookie from "js-cookie";

/**
 * 处理权限数据为目标格式
 * @param arr
 */
function dealPermissions(arr) {
  if (!arr || !Array.isArray(arr) || arr.length === 0) {
    return [];
  }
  let pArr = [];
  arr.map((val) => {
    if (!val) val = '';
    // let busStr = 'per_' + val.split(':')[0] || '';
    let busStr = val.split(':')[0] || '';
    let funcStr = val.split(':')[1] || '';
    let testArr = pArr.map((v, i) => {
      return {
        id: v.id,
        idx: i
      };
    }).filter((v) => {
      return busStr === v.id;
    });

    if (testArr.length > 0) {
      pArr[testArr[0].idx].operation.push(funcStr);
    } else {
      pArr.push({
        id: busStr,
        operation: [funcStr] //权限下的操作权限
      })
    }
  })
  return pArr;
}

export default {
  name: 'here',
  data() {
    return {
      logging: false,
      error: '',
      form: this.$form.createForm(this)
    }
  },
  computed: {
    systemName() {
      return this.$store.state.setting.systemName
    }
  },
  mounted() {
    if (this.$route.query.userId && this.$route.query.token) {
      const res = {
        code: 200,
        data: {
          token: this.$route.query.token,
          userId: this.$route.query.userId,
          expire: 86400
        }
      }
      this.afterLogin(res)
    }
  },
  methods: {
    ...mapMutations('account', ['setUser', 'setPermissions', 'setRoles']),
    onSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err) => {
        if (!err) {
          this.logging = true
          const username = this.form.getFieldValue('username')
          const password = this.form.getFieldValue('password')
          Cookie.set('Authorization', 'Bearertoken') // 设置默认token防止登录报错
          let _this = this
          login(username, password)
              .then(this.afterLogin)
              .catch(function () {
                // _this.$message.error(res.msg)
                _this.logging = false
              })
        }
      })
    },
    afterLogin(res) {
      this.logging = false
      const loginRes = res.data;
      if (res.code >= 200 && res.code < 300) {
        const {token, expire} = loginRes;
        localStorage.setItem('token', loginRes.token)
        setAuthorization({token: loginRes.token, expireAt: new Date(new Date().valueOf() + loginRes.expire * 1000)})

        getUserInfo().then(result => {
          const user = {
            userId: result.data.userId,
            token,
            expire,
            name: result.data.userName,
            avatar: result.data.headImg ? api.temp.FILE_PATH + result.data.headImg : require('@/assets/img/moren.png')
          }
          Cookie.set('shopId', result.data.shopId) // 设置默认token防止登录报错
          this.setUser(Object.assign(result.data, user));
        })

        getPermissions().then(result => {
          const permissions = dealPermissions(result.data);
          this.setPermissions(permissions || [])
        })

        // 获取路由配置
        getRoutesConfig().then(result => {
          const routesConfig = result.data
          // 将菜单数据格式转换为路由格式
          const vueRoutesConfig = convertMenuConfigToRouteConfig(routesConfig)

          loadRoutes(vueRoutesConfig)

          // 如果地址上传入了to参数，则尝试跳转到to指向的地址
          // 参考guard.js -> loginGuard()
          const routeQuery = this.$route.query
          const destRoute = routeQuery && routeQuery.to || '/workspace'
          this.$router.push(destRoute)
          // this.$message.success('登陆成功', 3)


        }).catch(e => {
          const vueRoutesConfig = convertMenuConfigToRouteConfig([])
          loadRoutes(vueRoutesConfig);
          const routeQuery = this.$route.query
          const destRoute = routeQuery && routeQuery.to || '/workspace'
          this.$router.push(destRoute)
          this.$message.error(e.msg, 3)
        })

      } else {
        this.error = loginRes.message
      }
    }
  }
}
</script>

<style lang="less" scoped>
//.ww_officialImg_DownloadIcon{
//  background-image: url(https://wwcdn.weixin.qq.com/node/wwnl/wwnl/style/images/officialImages$64a1bb5d.png);
//  background-position: 0 -89px;
//  width: 90px;
//  height: 90px;
//}
.ant-form {
  padding-right: 0;
}

.common-layout {
  .top {
    text-align: center;

    .boxes {
      div {
        width: 120px;
        height: 120px;
        display: inline-block;
        margin-right: 50px
      }

      span {
        display: inline-block;
        margin-top: 150px;
        font-size: 16px;
      }
      p{
        color: #c2c1c1;
        opacity: 0;
      }

      .first {
        margin-left: 50px;
        background-image: url(https://wwcdn.weixin.qq.com/node/wwnl/wwnl/style/images/officialImages$7ef49462.svg);
        background-position: 0 -120px;
        width: 120px;
        height: 120px;
      }

      .first:hover {
          background-image: url(https://wwcdn.weixin.qq.com/node/wwnl/wwnl/style/images/officialImages$64a1bb5d.png);
          background-position: 0 -89px;
        .p1{
          opacity: 100;
        }
      }

      .second {
        background-image: url(https://wwcdn.weixin.qq.com/node/wwnl/wwnl/style/images/officialImages$7ef49462.svg);
        background-position: -120px 0;
        width: 120px;
        height: 120px;
      }

      .second:hover {
        background-image: url(https://wwcdn.weixin.qq.com/node/wwnl/wwnl/style/images/officialImages$64a1bb5d.png);
        background-position: 0 -89px;
        .p2{
          opacity: 100;
        }

      }

      .third {

        background-image: url(https://wwcdn.weixin.qq.com/node/wwnl/wwnl/style/images/officialImages$7ef49462.svg);
        background-position: -120px -120px;
        width: 120px;
        height: 120px;
      }
      .third:hover {
        background-image: url(https://work.weixin.qq.com/wework_admin/genqrcode?action=commdownload&platform=ios&from=baidu&qr_size=4);
        background-size: 100%;
        .p3{
          opacity: 100;
        }
      }

      .forth {

        background-image: url(https://wwcdn.weixin.qq.com/node/wwnl/wwnl/style/images/officialImages$7ef49462.svg);
        background-position: 0 0px;
        width: 120px;
        height: 120px;
      }
      .forth:hover {

        background-image: url(https://work.weixin.qq.com/wework_admin/genqrcode?action=commdownload&platform=android&from=baidu&qr_size=4);
        background-size: 100%;
        .p4{
          opacity: 100;
        }
      }
    }

    .header {
      height: 44px;
      line-height: 44px;


      a {
        text-decoration: none;
      }

      .logo {
        height: 44px;
        vertical-align: top;
        margin-right: 16px;
      }

      .title {
        font-size: 33px;
        color: @title-color;
        font-family: 'Myriad Pro', 'Helvetica Neue', Arial, Helvetica, sans-serif;
        font-weight: 600;
        position: relative;
        top: 2px;
      }


    }

    .desc {
      font-size: 14px;
      color: @text-color-second;
      margin-top: 12px;
      margin-bottom: 40px;
    }
  }

  .login {
    width: 368px;
    margin: 0 auto;
    @media screen and (max-width: 576px) {
      width: 95%;
    }
    @media screen and (max-width: 320px) {
      .captcha-button {
        font-size: 14px;
      }
    }

    .icon {
      font-size: 24px;
      color: @text-color-second;
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: @primary-color;
      }
    }
  }
}
</style>
